import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldAlert, ShieldCheck } from 'lucide-react';
import { getDefaultAllowedPath, getPermissionLabel, isEmployerSuperAdmin } from '../../utils/rbac';
import useAuthStore from '../../store/authStore';

const AccessDenied = ({ requiredPermission, superAdminOnly = false }) => {
  const { user } = useAuthStore();
  const fallbackPath = getDefaultAllowedPath(user);

  return (
    <div className="min-h-screen bg-white px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto flex min-h-[calc(100vh-3rem)] max-w-3xl items-center justify-center">
        <section className="w-full rounded-lg border border-slate-200/80 bg-white p-6 shadow-[0_18px_44px_rgba(15,23,42,0.06)] sm:p-8">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-start">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-rose-50 text-rose-600">
              <ShieldAlert size={24} />
            </span>
            <div className="min-w-0 flex-1">
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-rose-500">Access restricted</p>
              <h1 className="mt-2 font-display text-2xl font-normal text-[#0b1f3a]">You do not have access to this area</h1>
              <p className="mt-3 text-sm leading-6 text-slate-600">
                {superAdminOnly
                  ? 'Only a Super admin can open roles and users.'
                  : `Your current role does not include ${getPermissionLabel(requiredPermission)} access.`}
              </p>

              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <Link
                  to={fallbackPath}
                  className="inline-flex items-center justify-center gap-2 rounded-md bg-sky-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-sky-700"
                >
                  <ArrowLeft size={16} />
                  Go back
                </Link>
                {isEmployerSuperAdmin(user) && (
                  <Link
                    to="/roles"
                    className="inline-flex items-center justify-center gap-2 rounded-md border border-slate-200 bg-white px-4 py-2.5 text-sm font-medium text-[#0b1f3a] transition hover:border-sky-200 hover:bg-[#eef9ff]"
                  >
                    <ShieldCheck size={16} />
                    Manage roles
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AccessDenied;
